export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6990.47159d5c.jpg";